module.exports = __webpack_public_path__ + "static/democracyworks-aabc70dda1905ec7469e40e894d2374f.png";